import { useChatSettingsOptions } from "./use-chat-settings-options";
import { useChatSettingsState } from "./use-chat-settings-state";
import { useChatSettingsSync } from "./use-chat-settings-sync";

// View-model настроек чата, собранная из трёх частей: значения стора и сеттеры
// (`use-chat-settings-state`), производные наборы доступных опций по выбранным
// model/mode (`use-chat-settings-options`) и оба sync-эффекта, приводящие
// устаревший выбор к реальному каталогу (`use-chat-settings-sync`). Панель
// по-прежнему получает один плоский объект — форма API не изменилась.
export function useChatSettingsForm() {
    const state = useChatSettingsState();
    const options = useChatSettingsOptions(state.artifactType, state.modelId, state.mode);
    useChatSettingsSync(state, options);

    const {
        // `currentMode` — внутренняя деталь синхронизации: панели он не нужен,
        // она работает с уже разложенными наборами осей.
        currentMode: _currentMode,
        ...exposedOptions
    } = options;

    return { ...state, ...exposedOptions };
}
